import {NamedStatisticDefault} from '.';

import {CHARITY_ITEM_NAME} from '@/resources/statisticItems';

export const statisticDefault: NamedStatisticDefault[] = [
  {
    name: 'hugeBenefit',
    title: 'Кибер cюрприз',
    imageLarge: {
      src: {
        png: 'static/ny25/surprise-320-2024-12-09-11-29-11.png 320w, static/ny25/surprise-760-2024-12-09-11-29-11.png 854w',
        avif: 'static/ny25/surprise-320-2024-12-09-11-29-11.avif 320w, static/ny25/surprise-760-2024-12-09-11-29-11.avif 854w',
        webp: 'static/ny25/surprise-320-2024-12-09-11-29-11.webp 320w, static/ny25/surprise-760-2024-12-09-11-29-11.webp 854w',
      },
      alt: 'Кибер cюрприз',
    },
    defaultStatistic: {
      title: '73 млрд ₽',
      description:
        'Столько кэшбэка мы выплатили клиентам в этом году. На эти деньги можно было бы сделать около 92,5 миллионов бутербродов с чёрной икрой.',
    },
    extraDescription: '',
  },
  {
    name: CHARITY_ITEM_NAME,
    title: 'Мишка краснокнижный',
    imageLarge: {
      src: {
        png: 'static/ny25/bear-320-2024-12-09-10-28-43.png 320w, static/ny25/bear-760-2024-12-09-10-28-43.png 854w',
        avif: 'static/ny25/bear-320-2024-12-09-10-28-43.avif 320w, static/ny25/bear-760-2024-12-09-10-28-43.avif 854w',
        webp: 'static/ny25/bear-320-2024-12-09-10-28-43.webp 320w, static/ny25/bear-760-2024-12-09-10-28-43.webp 854w',
      },
      alt: 'медведь',
    },
    defaultStatistic: {
      title: '1.7 млрд ₽',
      description: 'Столько пожертвований сделали клиенты Т‑Банка за год. Вместе мы — сладкая фабрика заботы!',
    },
    extraDescription: '',
  },
  {
    name: 'secMB',
    title: 'Ирис В-приложении-завис',
    imageLarge: {
      src: {
        png: 'static/ny25/Iris-320-2024-12-09-11-08-39.png 320w, static/ny25/Iris-760-2024-12-09-11-08-39.png 854w',
        avif: 'static/ny25/Iris-320-2024-12-09-11-08-39.avif 320w, static/ny25/Iris-760-2024-12-09-11-08-39.avif 854w',
        webp: 'static/ny25/Iris-320-2024-12-09-11-08-39.webp 320w, static/ny25/Iris-760-2024-12-09-11-08-39.webp 854w',
      },
      alt: 'ирис',
    },
    defaultStatistic: {
      title: '38 млрд',
      description:
        'Столько минут провели в мобильном приложении Т‑Банка все наши клиенты. За это время было бы посмотреть 202 млн раз «Иронию судьбы, или С легким паром!».',
    },
    extraDescription: '',
  },

  {
    name: 'deposit',
    title: 'Миллиончик',
    imageLarge: {
      src: {
        png: 'static/ny25/million-320-2024-12-09-09-41-46.png 320w, static/ny25/million-760-2024-12-09-09-41-46.png 854w',
        avif: 'static/ny25/million-320-2024-12-09-09-41-46.avif 320w, static/ny25/million-760-2024-12-09-09-41-46.avif 854w',
        webp: 'static/ny25/million-320-2024-12-09-09-41-46.webp 320w, static/ny25/million-760-2024-12-09-09-41-46.webp 854w',
      },
      alt: 'лимон',
    },
    defaultStatistic: {
      title: '666 971',
      description:
        'Столько финансовых целей по накопительным счетам достигли клиенты Т‑Банка за год. Собрали огромную коробку сладких побед!',
    },
    extraDescription: '',
  },
];
